export enum Size {
  S = 's',
  M = 'm',
}
